import { MedicalInformation } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { LinkSize } from '@dreryk/react-components';

import { MedicalInformationModalOpener, MedicalInformationModalOpenLink } from '~legacy.patient';

type MedicalInformationDetailsModalOpenerProps = {
   readonly medicalInformation: MedicalInformation;
};

export const MedicalInformationDetailsModalOpener = (props: MedicalInformationDetailsModalOpenerProps): JSX.Element => {
   return (
      <MedicalInformationModalOpener medicalInformation={props.medicalInformation}>
         {({ openModal }) => (
            <MedicalInformationModalOpenLink onClick={openModal} unsignedAttachmentCount={0} size={LinkSize.NORMAL} />
         )}
      </MedicalInformationModalOpener>
   );
};
